<template>
    <v-main class="promoter-list-page">
        <v-app-bar app flat light color="white">
            <AppbarBackIcon />
            <v-toolbar-title class="font-weight-bold">
                <span>推广员</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-app-bar>
        <v-container fluid class="content">
            <v-row dense>
                <v-col cols="6">
                    <v-text-field label="姓名" v-model="form.payout_fullname"></v-text-field>
                </v-col>
                <v-col cols="6">
                    <v-text-field label="手机号" type="number" v-model="form.payout_phone"></v-text-field>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="6">
                    <v-text-field label="商户用户ID" type="text" v-model="form.customer_external_id"></v-text-field>
                </v-col>
                <v-col cols="6">
                    <v-text-field label="艺爪用户ID" type="number" v-model="form.customer_id"></v-text-field>
                </v-col>
            </v-row>
            <div class="d-flex justify-center">
                <v-btn class="mt-8 mb-4" color="primary" :width="128" @click="onQuery">查询</v-btn>
            </div>
            <div class="promoter-list">
                <div class="promoter-item" v-for="promoter in promoterList" :key="promoter.customer_id"
                    @click="handlePromoter(promoter)">
                    <div class="d-flex justify-space-between align-center">
                        <div class="d-flex align-center">
                            <div class="font-weight-bold">{{ promoter.payout_fullname || '------' }}</div>
                            <div class="ml-2 text--secondary">{{ promoter.payout_phone || '---' }}</div>
                            <div v-if="!promoter.has_payout_qrcode" class="promoter-label promoter-no-qrcode">无收款码</div>
                        </div>
                        <div class="d-flex align-center">
                            <div class="text--secondary">佣金</div>
                            <div class="ml-2 font-weight-bold">{{ profitRatioText(promoter) }}</div>
                        </div>
                    </div>
                    <div class="d-flex justify-space-between align-center">
                        <div class="text--secondary promoter-info-small">{{ promoter.customer_id }}</div>
                        <div class="text--secondary promoter-info-small">{{ promoter.dt_created }}</div>
                    </div>

                </div>
            </div>
        </v-container>
    </v-main>
</template>
  
<script>
import AppbarBackIcon from '@/components/AppbarBackIcon.vue'
import { formatProfitRatio } from '@/plugins/promoter'
import { homeStore } from '@/store/home'
import { promoterStore } from '@/store/promoter/promoter'
import _ from 'lodash'

export default {
    name: 'PromoterListPage',
    components: { AppbarBackIcon },
    data() {
        return {
            form: {
                payout_fullname: null,
                payout_phone: null,
                customer_external_id: null,
                customer_id: null,
            }
        }
    },
    computed: {
        promoterList() {
            return promoterStore.list
        },
    },
    async mounted() {
        await homeStore.doLoad()
    },
    methods: {
        profitRatioText(promoter) {
            return formatProfitRatio(promoter.profit_ratio)
        },
        handlePromoter(promoter) {
            this.$router.push({
                path: '/dash/promoter-detail',
                query: { id: promoter.customer_id },
            })
        },
        async onQuery() {
            let customer_id_s = null
            if (!_.isNil(this.form.customer_id) && this.form.customer_id !== '') {
                customer_id_s = [this.form.customer_id]
            }
            let result = await promoterStore.doLoad({
                payout_fullname: this.form.payout_fullname,
                payout_phone: this.form.payout_phone,
                customer_external_id: this.form.customer_external_id,
                customer_id_s: customer_id_s,
            })
            if (result.item_s.length <= 0) {
                this.$toasted.info('暂无推广员')
            }
        }
    },
}
</script>
  
<style lang="less" scoped>
@import '~@/styles/common';

.promoter-list {
    padding-top: 16px;
    padding-bottom: 16px;
}

.promoter-item {
    margin-top: 4px;
    padding: 8px;
    cursor: pointer;

    &:hover {
        background: rgba(0, 0, 0, 0.05);
    }
}

.promoter-label {
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
    padding-left: 6px;
    padding-right: 6px;
    font-size: 12px;
    font-weight: bold;
    border-radius: 12px;
    border: solid 1px;
}

.promoter-no-qrcode {
    border-color: @antGold;
    color: @antGold;
}

.promoter-info-small {
    font-size: 12px;
}
</style>
  